module.exports = __webpack_public_path__ + "img/image_not_available.fd72cd4d.png";